export default __webpack_public_path__ + "static/media/section2-7-num1.078e7096.png";